import { Mesh, MeshBasicMaterial, Object3D, PlaneGeometry, Quaternion, Vector3 } from 'three';
import { ActionControllerEventName, DragndropController, ParentEvent, ResourcesManager, ResourceType, ScenarioProcessor, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import TasksProgress from '../components/TasksProgress';
import TaskScreen from '../components/TaskScreen';
import WelcomeScreen from '../components/WelcomeScreen';
import { Apparat } from './SpectrophotometerLevelModules/Spectrophotometer';
import { Notebook } from './SpectrophotometerLevelModules/Notebook';
import { TestTubesHolder } from './SpectrophotometerLevelModules/TestTubesHolder';
import { TestTube } from './SpectrophotometerLevelModules/TestTube';
import { RedColoring } from './SpectrophotometerLevelModules/RedColoring';
import { Water } from './SpectrophotometerLevelModules/Water';
import LobbyScreen from '../components/LobbyScreen';
import ErrorModal from '../components/ErrorModal';
import { MaterialImprovement } from '../utils/MaterialImprovement';
import { zSpaceConfig } from '../config';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from '../utils/PreparationPickingObjects';
const values_array = [
    {
        wavelength: 380,
        absorbance: 845,
        transmittance: 12.4
    }, {
        wavelength: 405,
        absorbance: 1130,
        transmittance: 7.4
    }, {
        wavelength: 430,
        absorbance: 1310,
        transmittance: 5
    }, {
        wavelength: 455,
        absorbance: 1800,
        transmittance: 1.6
    },
];
export class SpectrophotometerLevel extends ViewerModule {
    constructor(levelNumber, titleText, lobby) {
        super();
        this.levelNumber = levelNumber;
        this.titleText = titleText;
        this.lobby = lobby;
        this.wrapScreenPosition = new Vector3(-3.52, 1.54, -5.15);
        this.levelFinished = false;
        this.cameraPositionVR = new Vector3(34.77503, -15.5979, 10.7939);
        this.waterDefaultPosition = new Vector3(-1.5990841298286511, -3.2294973237596807, 0.44137392104354767);
        this.coloringDefaultPosition = new Vector3(-0.8108225355212769, -3.2953977149529754, 0.44137392104354767);
        this._interaction = false;
        this.pointerController = Viewer.pointerController;
        this.uiObject.name = 'SPECTROPHOTOMETER LEVEL';
        this.resourcesInUse = [
            {
                name: 'table_spectro',
                type: ResourceType.FBX_MODEL,
                priority: 0,
                url: require('../../assets/models/spectrophotometer/table.fbx')
            },
        ];
        this.zSpacePositions = zSpaceConfig.spectrophotometer;
        this.cameraPosition = new Vector3(34.77503, -13.5979, 10.7939);
        this.cameraTargetNormal = new Vector3(34.784, -13.6, 10.79);
        this.addObject(this.spectrophotometerApparat = new Apparat());
        this.spectrophotometerApparat.uiObject.position.set(5.07, -1.64, .1);
        this.spectrophotometerApparat.uiObject.rotation.set(0, -.64, 0);
        this.spectrophotometerApparat.uiObject.scale.set(1.5, 1.5, 1.5);
        this.spectrophotometerApparat.uiObject.name = 'spectrophotometerApparat';
        this.addObject(this.notebook = new Notebook());
        this.notebook.uiObject.position.set(-3.1466130678453097, -3.75, 1.8579541226789735);
        this.notebook.uiObject.rotation.set(0, -0.35993976090689883, 0);
        this.notebook.uiObject.scale.setScalar(0.15);
        if (Viewer.controls.zController)
            this.notebook.uiObject.scale.setScalar(0.15);
        this.addObject(this.testTubesHolder = new TestTubesHolder());
        this.testTubesHolder.uiObject.position.set(-0.05, -3.45, 2.65);
        this.testTubesHolder.uiObject.rotation.set(0, -1.5297465999498303, 0);
        this.addObject(this.testTube1 = new TestTube(this));
        this.addObject(this.testTube2 = new TestTube(this));
        this.addObject(this.water = new Water());
        this.water.uiObject.position.copy(this.waterDefaultPosition);
        this.addObject(this.redColoring = new RedColoring());
        this.redColoring.uiObject.position.copy(this.coloringDefaultPosition);
        this.addObject(this.waterAndColoringLocationsWrapper = new Object3D());
        this.addObject(this.coloringLocation = new Mesh(new PlaneGeometry(0.5, 0.5).rotateX(-Math.PI / 2), new MeshBasicMaterial({ color: 'green' })), null, this.waterAndColoringLocationsWrapper);
        this.coloringLocation.position.set(-0.8108225355212769, -3.92679884304654, 0.44137392104354767);
        this.addObject(this.waterLocation = new Mesh(new PlaneGeometry(0.5, 0.5).rotateX(-Math.PI / 2), new MeshBasicMaterial({ color: 'green' })), null, this.waterAndColoringLocationsWrapper);
        this.waterLocation.position.set(-1.5990841298286511, -3.92679884304654, 0.44137392104354767);
    }
    get interaction() {
        return this._interaction;
    }
    set interaction(value) {
        this._interaction = value;
        console.log('SPECTROPHOTOMETER LEVEL INTERACTION = ', this._interaction);
    }
    init() {
        this.table = ResourcesManager.getModel('table_spectro');
        this.table.name = 'TABLE';
        this.table.position.set(2.35, -7, 1.6);
        this.addObject(this.table);
        this.spectrophotometerApparat.init();
        this.notebook.init(this);
        this.testTubesHolder.init();
        this.testTube1.init();
        this.testTube2.init();
        this.water.init();
        this.redColoring.init();
        this.addUI();
        this.addLobbyUI(this.levelNumber, this.titleText);
        this.initScenario();
    }
    restart() {
        this.pointerController.setObject();
        this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject && this.lobby.app.zSpacePickingController.forceRelease();
        this.interaction = false;
        this.spectrophotometerApparat.reset();
        this.notebook.reset();
        this.testTube1.reset();
        this.testTube2.reset();
        this.redColoring.reset();
        this.water.reset();
        this.water.uiObject.position.copy(this.waterDefaultPosition);
        if (!this.water.uiObject.parent)
            this.uiObject.add(this.water.uiObject);
        this.redColoring.uiObject.position.copy(this.coloringDefaultPosition);
        if (!this.redColoring.uiObject.parent)
            this.uiObject.add(this.redColoring.uiObject);
        this.intermediateScreen.off('ok');
        this.actionController.off(null, this.water.uiObject);
        [this.testTube1, this.testTube2].forEach(testTube => {
            this.actionController.off(null, testTube.uiObject);
            if (this.lobby.app.zSpacePickingController)
                this.lobby.app.zSpacePickingController.off(null, testTube.model);
            const wrapTestTubePlaceholder = testTube.placeholder.object;
            wrapTestTubePlaceholder.children[0].visible = false;
            this.actionController.off(null, wrapTestTubePlaceholder);
            testTube.off('took');
            testTube.uiObject.userData.viewerCallback && Viewer.off('update', testTube.uiObject.userData.viewerCallback);
            testTube.off('drop_filled');
        });
        const wrapTubePlaceholder = this.placeholdersApparat.object;
        wrapTubePlaceholder.children[0].visible = false;
        this.actionController.off(null, wrapTubePlaceholder);
        this.actionController.off(null, this.waterAndColoringLocationsWrapper);
        this.actionController.off(null, this.redColoring.uiObject);
        this.spectrophotometerApparat.off('numericValueChanged');
        this.spectrophotometerApparat.off('modeChanged');
        this.notebook.off('entered');
        this.initScenario();
    }
    addUI() {
        this.uiContainer = new Object3D();
        this.uiContainer.name = 'uiContainer';
        this.uiContainer.visible = false;
        this.addObject(this.uiContainer);
        this.addObject(this.errorModal = new ErrorModal(), null, this.uiContainer);
        this.errorModal.on('ok', () => this.errorModal.uiObject.visible = false);
        this.errorModal.init('Error', 'Wrong value entered. \n Try again.');
        this.errorModal.uiObject.position.set(0, 0, -2.2);
        this.errorModal.uiObject.visible = false;
        this.errorModal.uiObject.name = 'ERROR MODAL';
        this.addObject(this.tasksProgress = new TasksProgress(), null, this.uiContainer);
        this.tasksProgress.uiObject.position.set(0, 3.3, -5);
        this.tasksProgress.uiObject.name = 'TASK PROGRESS';
        this.addObject(this.taskScreen = new TaskScreen(), null, this.uiContainer);
        this.taskScreen.uiObject.position.set(0, 0, -5);
        this.taskScreen.uiObject.name = 'TASK SCREEN';
        this.addObject(this.welcomeScreen = new WelcomeScreen(), null, this.uiContainer);
        this.welcomeScreen.uiObject.position.set(0, 1, 1);
        this.welcomeScreen.uiObject.name = 'welcomeScreen';
        this.welcomeScreen.uiObject.visible = false;
        this.welcomeScreen.on('ok', () => {
            this.fire('exit', new ParentEvent('exit'));
            this.title.setProgress('6/6');
        });
        this.welcomeScreen.on('secondButtonClick', () => {
            this.welcomeScreen.uiObject.visible = false;
        });
        this.addObject(this.intermediateScreen = new WelcomeScreen(), null, this.uiContainer);
        this.intermediateScreen.uiObject.position.set(0, 1.5, -2);
        this.intermediateScreen.uiObject.name = 'intermediateScreen';
        this.intermediateScreen.uiObject.visible = false;
    }
    addLobbyUI(levelNumber, title) {
        let lobbyUI = new Object3D();
        lobbyUI.name = 'LOBBY UI';
        this.addObject(lobbyUI);
        this.title = new LobbyScreen();
        this.title.init('Level ' + levelNumber, title, '0/10');
        lobbyUI.add(this.title.uiObject);
        this.title.uiObject.position.y = 10;
        this.title.on('start', () => {
            if (this.pointerController.currentPointerObject !== this.pointerController.defaultPointerObject)
                return;
            this.fire('start', new ParentEvent('start'));
        });
        this.on('started', () => {
            this.interaction = true;
        });
        this.title.on('tutorial', () => {
            this.fire('tutorial');
        });
    }
    initScenario() {
        var _a;
        MaterialImprovement.upgradeMaterialsFromModel(this.table, this.uiObject.name);
        const dragndropController = new DragndropController(Viewer.pointerController);
        dragndropController.interactDisabled = false;
        this.dragndropGroup = dragndropController.registerGroup('Spectrophotometer dragndrop group');
        const placeholdersTestTubesHolder = this.placeholdersTestTubesHolder = this.testTubesHolder.getPlaceholders(this.dragndropGroup);
        const placeholdersApparat = this.placeholdersApparat = this.spectrophotometerApparat.getTestTubePlaceholder(this.dragndropGroup);
        const testTube1Draggable = this.testTube1.getDraggable(this.dragndropGroup);
        // testTube1Draggable.canBeDragged = true;
        this.testTube1.uiObject.userData.positionForPlaceholder = new Vector3();
        const testTube2Draggable = this.testTube2.getDraggable(this.dragndropGroup);
        this.testTube2.uiObject.userData.positionForPlaceholder = new Vector3();
        // testTube2Draggable.canBeDragged = true;
        placeholdersTestTubesHolder[0].object.add(this.testTube1.uiObject);
        placeholdersTestTubesHolder[1].object.add(this.testTube2.uiObject);
        this.testTube1.placeholder = placeholdersTestTubesHolder[0];
        this.testTube2.placeholder = placeholdersTestTubesHolder[1];
        placeholdersApparat.on('drag', (event) => {
            this.spectrophotometerApparat.on('capChanged', (eventCap) => eventCap.data.openned, (eventCap) => event.data.draggable.canBeDragged = true);
            this.spectrophotometerApparat.on('capChanged', (eventCap) => !eventCap.data.openned, (eventCap) => event.data.draggable.canBeDragged = false);
            setTimeout(() => event.data.draggable.once('drag', () => this.spectrophotometerApparat.off('capChanged')), 0);
        });
        const totalTasks = 7;
        this.scenario = {
            name: 'scenarioName',
            modules: [
                { name: 'tasksProgress', instance: this.tasksProgress },
                { name: 'taskScreen', instance: this.taskScreen },
                { name: 'welcomeScreen', instance: this.welcomeScreen },
                { name: 'intermediateScreen', instance: this.intermediateScreen },
                { name: 'lobbyScreen', instance: this.title },
                { name: 'spectrophotometerApparat', instance: this.spectrophotometerApparat },
                { name: 'notebook', instance: this.notebook },
                { name: 'testTubesHolder', instance: this.testTubesHolder },
                { name: 'testTube1', instance: this.testTube1 },
                { name: 'testTube2', instance: this.testTube2 },
                { name: 'water', instance: this.water },
                { name: 'redColoring', instance: this.redColoring },
                { name: 'errorModal', instance: this.errorModal },
            ],
            steps: [
                {
                    onBefore: [
                        ['tasksProgress', 'init', 6, 0],
                        ['lobbyScreen', 'setProgress', '0/6'],
                        [
                            'intermediateScreen', 'init', 'Welcome to Level 5!',
                            'Today we will be performing an experiment to determine the absorbance spectrum of red food coloring. \n \n ' +
                                'First, let\'s prepare the dilution.',
                            'Start'.toUpperCase(),
                        ],
                        ['intermediateScreen', 'show']
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.intermediateScreen.once('ok', () => {
                            this.intermediateScreen.uiObject.visible = false;
                            resolve();
                        });
                    }),
                },
                {
                    onBefore: [
                        [
                            'taskScreen', 'init', 'Task 1: Prepare Dilution',
                            'Fill both test tubes with water.',
                            ((_a = Viewer.zSpace) === null || _a === void 0 ? void 0 : _a.enabled)
                                ? ('First, pick up the water container and fill up each of the test tubes while tilted. \n ' +
                                    'Once both tubes are full, put the water back to the table.')
                                : ('First, click on the water container to pick it up. \n ' +
                                    'Next, drag the water over each test tube to fill it with water. \n ' +
                                    'Once both tubes are full, drag the water back to the table.'),
                            .4
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.actionController.once(ActionControllerEventName.click, this.water.uiObject, (event) => {
                            if (event.orderNumber !== 0)
                                return;
                            const pointerWraper = new Object3D();
                            pointerWraper.rotation.set(0, 0, 0);
                            pointerWraper.add(this.water.uiObject);
                            pointerWraper.name = 'water';
                            if (!Viewer.controls.zController) {
                                Viewer.pointerController.setObject(this.water.uiObject);
                                this.water.setAsPointerControllerObject(true);
                            }
                            else {
                                pointerWraper.position.copy(this.water.uiObject.position);
                                const matrixWorld = this.water.uiObject.matrixWorld.clone();
                                PreparationPickingObjects.saveObjectState(pointerWraper);
                                PreparationPickingObjects.saveObjectState(this.water.uiObject);
                                pointerWraper.traverse(el => {
                                    el.userData._raycast = el.raycast;
                                    el.raycast = () => { };
                                });
                                Viewer.scene.add(pointerWraper);
                                pointerWraper.position.setFromMatrixPosition(matrixWorld);
                                pointerWraper.scale.setFromMatrixScale(matrixWorld);
                                this.water.uiObject.position.set(0, 0, 0);
                                this.water.uiObject.rotation.set(0, 0, 0);
                                pointerWraper.updateMatrixWorld(true);
                                this.lobby.app.zSpacePickingController.forcePickUp(pointerWraper, event.distance, event.ray.origin.clone().add(event.ray.direction.clone().multiplyScalar(0.3 * 0.99)), new Quaternion().setFromUnitVectors(new Vector3(0, 0, -1), event.ray.direction), 0);
                            }
                            dragndropController.interactDisabled = true;
                            resolve();
                        });
                    }),
                    onError: [['errorModal', 'setText', '1 step onError']]
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        let i = 0;
                        if (!Viewer.controls.zController) {
                            [this.testTube1, this.testTube2].forEach(testTube => {
                                this.actionController.once(ActionControllerEventName.click, testTube.uiObject, () => Viewer.pointerController.currentPointerObject === this.water.uiObject || (this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject.children.indexOf(this.water.uiObject) > -1), (event) => {
                                    testTube.addWater();
                                    if (++i === 2) {
                                        resolve();
                                        this.water.setDynamicLiquidMode(false);
                                    }
                                });
                            });
                        }
                        else {
                            this.water.setDynamicLiquidMode(true);
                            [this.testTube1, this.testTube2].forEach(testTube => {
                                Viewer.on('update', testTube.uiObject.userData.viewerCallback = () => {
                                    this.water.drops.slice().forEach(drop => {
                                        if (drop.userData.sphere.center.distanceTo(testTube.uiObject.localToWorld(new Vector3(0, 0, 0))) < 0.3) {
                                            this.water.removeDrop(drop);
                                            testTube.addDrop(1);
                                        }
                                    });
                                });
                                testTube.once('drop_filled', () => {
                                    testTube.addWater();
                                    if (++i === 2) {
                                        this.water.setDynamicLiquidMode(false);
                                        [this.testTube1, this.testTube2].forEach(testTube => {
                                            testTube.uiObject.userData.viewerCallback && Viewer.off('update', testTube.uiObject.userData.viewerCallback);
                                        });
                                        resolve();
                                    }
                                });
                            });
                        }
                    }),
                    onError: [['errorModal', 'setText', '1 step onError']]
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        if (Viewer.controls.zController) {
                            let waterAndColoringLocationsWrapperCallback;
                            this.actionController.on(ActionControllerEventName.click, Viewer.scene, waterAndColoringLocationsWrapperCallback = (event) => {
                                if (Viewer.pointerController.currentPointerObject === this.water.uiObject || (this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject.children.indexOf(this.water.uiObject) > -1)) {
                                    const distanceToWaterAndColoringLocationsWrapper = this.water.model.getWorldPosition(new Vector3()).distanceTo(this.waterLocation.getWorldPosition(new Vector3()));
                                    if (distanceToWaterAndColoringLocationsWrapper < 1.2) {
                                        this.actionController.off(ActionControllerEventName.click, Viewer.scene, waterAndColoringLocationsWrapperCallback);
                                        this.uiObject.add(this.water.uiObject);
                                        this.water.uiObject.position.copy(this.waterDefaultPosition);
                                        this.water.setAsPointerControllerObject(false);
                                        dragndropController.interactDisabled = false;
                                        resolve();
                                    }
                                }
                            });
                        }
                        else {
                            this.actionController.once(ActionControllerEventName.click, this.waterAndColoringLocationsWrapper, (event) => {
                                if (Viewer.pointerController.currentPointerObject === this.water.uiObject || (this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject.children.indexOf(this.water.uiObject) > -1)) {
                                    Viewer.pointerController.setObject(null);
                                    // if (Viewer.controls.zController) {
                                    //     this.lobby.app.zSpacePickingController.forceRelease();
                                    // }
                                    this.uiObject.add(this.water.uiObject);
                                    this.water.uiObject.position.copy(this.waterDefaultPosition);
                                    this.water.setAsPointerControllerObject(false);
                                    dragndropController.interactDisabled = false;
                                    resolve();
                                }
                            });
                        }
                    }),
                    onError: [['errorModal', 'setText', '1 step onError']]
                },
                {
                    onBefore: [['tasksProgress', 'init', 6, 1],
                        ['lobbyScreen', 'setProgress', '1/6'],
                        [
                            'taskScreen', 'init', 'Task 1: Prepare Dilution',
                            'Dilute Red Solution.',
                            'First, click on the red solution container to pick it up. \n ' +
                                'Next, drag the solution over one test tube to fill it with solution. \n ' +
                                'Once one test tube is red, drag the solution back to the table.',
                            0.3
                        ]
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.actionController.once(ActionControllerEventName.click, this.redColoring.uiObject, (event) => {
                            if (event.orderNumber > 1)
                                return;
                            const pointerWraper = new Object3D();
                            pointerWraper.rotation.set(0, 0, 0);
                            pointerWraper.add(this.redColoring.uiObject);
                            pointerWraper.name = 'redColoring';
                            if (!Viewer.controls.zController) {
                                Viewer.pointerController.setObject(this.redColoring.uiObject);
                                this.redColoring.setAsPointerControllerObject(true);
                            }
                            else {
                                pointerWraper.position.copy(this.redColoring.uiObject.position);
                                const matrixWorld = this.redColoring.uiObject.matrixWorld.clone();
                                PreparationPickingObjects.saveObjectState(pointerWraper);
                                PreparationPickingObjects.saveObjectState(this.redColoring.uiObject);
                                pointerWraper.traverse(el => {
                                    el.userData._raycast = el.raycast;
                                    el.raycast = () => { };
                                });
                                Viewer.scene.add(pointerWraper);
                                pointerWraper.position.setFromMatrixPosition(matrixWorld);
                                pointerWraper.scale.setFromMatrixScale(matrixWorld);
                                this.redColoring.uiObject.position.set(0, 0, 0);
                                this.redColoring.uiObject.rotation.set(0, 0, 0);
                                // this.redColoring.setAsPointerControllerObject(true);
                                pointerWraper.updateMatrixWorld(true);
                                this.lobby.app.zSpacePickingController.forcePickUp(pointerWraper, event.distance, event.ray.origin.clone().add(event.ray.direction.clone().multiplyScalar(0.3 * 0.99)), new Quaternion().setFromUnitVectors(new Vector3(0, 0, -1), event.ray.direction), 0);
                            }
                            dragndropController.interactDisabled = true;
                            resolve();
                        });
                    }),
                    onError: [['errorModal', 'setText', '1 step onError']]
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        let j = 0;
                        if (!Viewer.controls.zController) {
                            const callbacks = [this.testTube1, this.testTube2].map((testTube, i, arr) => {
                                return this.actionController.once(ActionControllerEventName.click, testTube.uiObject, () => Viewer.pointerController.currentPointerObject === this.redColoring.uiObject || (this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject.children.indexOf(this.redColoring.uiObject) > -1), (event) => {
                                    if (i !== 1) {
                                        const helpTube2 = this.testTube2;
                                        this.testTube2 = testTube;
                                        this.testTube1 = helpTube2;
                                    }
                                    testTube.addColor();
                                    if (++j === 1) {
                                        this.actionController.off(ActionControllerEventName.click, arr[arr.length - 1 - i].uiObject, callbacks[arr.length - 1 - i]);
                                        resolve();
                                    }
                                });
                            });
                        }
                        else {
                            this.redColoring.setDynamicLiquidMode(true);
                            [this.testTube1, this.testTube2].forEach((testTube, i) => {
                                Viewer.on('update', testTube.uiObject.userData.viewerCallback = () => {
                                    this.redColoring.drops.slice().forEach(drop => {
                                        if (drop.userData.sphere.center.distanceTo(testTube.uiObject.localToWorld(new Vector3(0, 0, 0))) < 0.3) {
                                            this.redColoring.removeDrop(drop);
                                            testTube.addColoringDrop(1);
                                        }
                                    });
                                });
                                testTube.once('coloring_drop_filled', () => {
                                    testTube.addColor();
                                    this.redColoring.setDynamicLiquidMode(false);
                                    [this.testTube1, this.testTube2].forEach(testTube => {
                                        testTube.uiObject.userData.viewerCallback && Viewer.off('update', testTube.uiObject.userData.viewerCallback);
                                    });
                                    if (i !== 1) {
                                        const helpTube2 = this.testTube2;
                                        this.testTube2 = testTube;
                                        this.testTube1 = helpTube2;
                                    }
                                    resolve();
                                });
                            });
                        }
                    }),
                    onError: [['errorModal', 'setText', '1 step onError']]
                },
                {
                    onBefore: [],
                    stepCondition: () => new Promise((resolve, reject) => {
                        if (Viewer.controls.zController) {
                            let waterAndColoringLocationsWrapperCallback;
                            this.actionController.on(ActionControllerEventName.click, Viewer.scene, waterAndColoringLocationsWrapperCallback = (event) => {
                                if (Viewer.pointerController.currentPointerObject === this.redColoring.uiObject || (this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject.children.indexOf(this.redColoring.uiObject) > -1)) {
                                    const distanceToWaterAndColoringLocationsWrapper = this.water.model.getWorldPosition(new Vector3()).distanceTo(this.coloringLocation.getWorldPosition(new Vector3()));
                                    if (distanceToWaterAndColoringLocationsWrapper < 1.2) {
                                        this.actionController.off(ActionControllerEventName.click, Viewer.scene, waterAndColoringLocationsWrapperCallback);
                                        this.lobby.app.zSpacePickingController.forceRelease();
                                        this.uiObject.add(this.redColoring.uiObject);
                                        this.redColoring.uiObject.position.copy(this.coloringDefaultPosition);
                                        dragndropController.interactDisabled = false;
                                        resolve();
                                    }
                                }
                            });
                        }
                        else {
                            this.actionController.once(ActionControllerEventName.click, this.waterAndColoringLocationsWrapper, (event) => {
                                if (Viewer.pointerController.currentPointerObject === this.redColoring.uiObject || (this.lobby.app.zSpacePickingController && this.lobby.app.zSpacePickingController.currentObject.children.indexOf(this.redColoring.uiObject) > -1)) {
                                    Viewer.pointerController.setObject(null);
                                    if (Viewer.controls.zController) {
                                        this.lobby.app.zSpacePickingController.forceRelease();
                                    }
                                    this.uiObject.add(this.redColoring.uiObject);
                                    this.redColoring.uiObject.position.copy(this.coloringDefaultPosition);
                                    this.redColoring.setAsPointerControllerObject(false);
                                    dragndropController.interactDisabled = false;
                                    resolve();
                                }
                            });
                        }
                    }),
                    onError: [['errorModal', 'setText', '1 step onError']]
                },
                {
                    onBefore: [
                        [
                            'intermediateScreen', 'init', 'Good Job!',
                            'Now that we have prepared the dilution, let\'s begin using the spectrophotometer to determine the transmittance & absorbance of light at different wavelengths.',
                            'Continue'.toUpperCase()
                        ],
                        ['intermediateScreen', 'show']
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.intermediateScreen.once('ok', () => {
                            this.intermediateScreen.uiObject.visible = false;
                            resolve();
                        });
                    }),
                },
                ...(() => {
                    let arr = [];
                    [380, 405, 430, 455].forEach((waveLength, i) => {
                        var _a, _b;
                        // [380].forEach((waveLength, i) => {
                        arr = arr.concat(...[
                            {
                                onBefore: [
                                    [`tasksProgress`, `init`, `6`, i + 2],
                                    ['spectrophotometerApparat', 'enableInteraction', 'wavelength'],
                                    ['lobbyScreen', 'setProgress', `${i + 2}/6`],
                                    [
                                        `taskScreen`, `init`,
                                        `Task ${i + 2}.1: Prepare for a wavelength of ${waveLength}nm`,
                                        `Set the Wavelength to ${waveLength}nm.`,
                                        ((_a = Viewer.zSpace) === null || _a === void 0 ? void 0 : _a.enabled)
                                            ? ('First select the wavelength control knob. \n ' +
                                                `Next, press the Left or Right buttons on stylus to set the wavelength to ${waveLength}.`)
                                            : (`First select the wavelength control knob. \n ` +
                                                `Next, press the + or - buttons to set the wavelength to ${waveLength}.`),
                                        .9
                                    ],
                                ],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    this.spectrophotometerApparat.once('numericValueChanged', (event) => event.data.valueChanged === 'wavelength' && event.data.newValue === waveLength, () => {
                                        this.spectrophotometerApparat.plusButton && (this.spectrophotometerApparat.plusButton.uiObject.visible = false);
                                        this.spectrophotometerApparat.minusButton && (this.spectrophotometerApparat.minusButton.uiObject.visible = false);
                                        resolve();
                                    });
                                }),
                                onError: [() => console.log('error')]
                            },
                            {
                                onBefore: [
                                    ['spectrophotometerApparat', 'enableInteraction', 'mode'],
                                    [
                                        `taskScreen`, `init`,
                                        `Task ${i + 2}.1: Prepare for a wavelength of ${waveLength}nm`,
                                        `Set the Display to Transmittance.`,
                                        `Press the mode button until the red light on the display is next to transmittance.`,
                                        .9
                                    ]
                                ],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    this.spectrophotometerApparat.once('modeChanged', (event) => event.data.newValue === 0, () => resolve());
                                }),
                            },
                            (i === 0 ?
                                {
                                    onBefore: [
                                        ['spectrophotometerApparat', 'enableInteraction', 'zeroAdjustKnob'],
                                        [
                                            `taskScreen`, `init`,
                                            `Task ${i + 2}.1: Prepare for a wavelength of ${waveLength}nm`,
                                            `Set the data display to 0%.`,
                                            ((_b = Viewer.zSpace) === null || _b === void 0 ? void 0 : _b.enabled)
                                                ? ('First select the zero adjust knob. \n ' +
                                                    `Next, press the Left or Right buttons on stylus to set the data to 0%.`)
                                                : (`First select the zero adjust knob. \n ` +
                                                    `Next, press the + or - buttons to set the data to 0%.`),
                                            .9
                                        ],
                                    ],
                                    stepCondition: () => new Promise((resolve, reject) => {
                                        this.spectrophotometerApparat.once('numericValueChanged', (event) => event.data.valueChanged === 'zeroAdjustKnob' && event.data.newValue === 0, () => {
                                            this.spectrophotometerApparat.plusButton.uiObject.visible = false;
                                            this.spectrophotometerApparat.minusButton.uiObject.visible = false;
                                            resolve();
                                        });
                                    }),
                                    onAfter: [['spectrophotometerApparat', 'enableInteraction', null]]
                                } : null),
                            {
                                onBefore: [
                                    [
                                        `taskScreen`, `init`,
                                        `Task ${i + 2}.2: Load blank test tube`,
                                        `Load blank test tube.`,
                                        `Select the blank test tube and drag it to the Spectrophotometer.`,
                                        1
                                    ],
                                ],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    this.testTube1.setDraggable(true);
                                    this.testTube1.once('took', () => {
                                        const wrapTubePlaceholder = placeholdersApparat.object;
                                        wrapTubePlaceholder.children[0].visible = true;
                                        if (!Viewer.controls.zController) {
                                            this.actionController.once(ActionControllerEventName.click, wrapTubePlaceholder, () => {
                                                Viewer.pointerController.setObject(null);
                                                this.testTube1.model.userData.tablePosition = this.testTube1.model.position.clone();
                                                this.testTube1.model.userData.tableParent = this.testTube1.model.parent;
                                                this.spectrophotometerApparat.addObject(this.testTube1.model);
                                                this.testTube1.model.position.copy(wrapTubePlaceholder.position);
                                                wrapTubePlaceholder.children[0].visible = false;
                                                resolve();
                                            });
                                        }
                                        else {
                                            this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.testTube1.model, () => {
                                                const distanceToTubePlaceholder = wrapTubePlaceholder.getWorldPosition(new Vector3()).distanceTo(this.testTube1.model.getWorldPosition(new Vector3()));
                                                if (distanceToTubePlaceholder < 1.1) {
                                                    this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.testTube1.model);
                                                    this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.testTube1.model);
                                                    this.testTube1.model.userData.tablePosition = this.testTube1.model.position.clone();
                                                    this.testTube1.model.userData.tableParent = this.testTube1.model.parent;
                                                    this.spectrophotometerApparat.addObject(this.testTube1.model);
                                                    this.testTube1.model.position.copy(wrapTubePlaceholder.position);
                                                    this.testTube1.model.quaternion.copy(wrapTubePlaceholder.quaternion);
                                                    this.testTube1.model.scale.copy(wrapTubePlaceholder.scale);
                                                    wrapTubePlaceholder.children[0].visible = false;
                                                    resolve();
                                                }
                                                else {
                                                    PreparationPickingObjects.flyObjectToPrevState(this.testTube1.model, 0);
                                                }
                                                setTimeout(() => this.testTube1.model.traverse(el => {
                                                    if (el.userData.oldRaycast)
                                                        el.raycast = el.userData.oldRaycast;
                                                }));
                                            });
                                        }
                                    });
                                }),
                                onAfter: [
                                    ['spectrophotometerApparat', 'toggleCap', false],
                                    ['spectrophotometerApparat', 'setValues', 35, 0]
                                ],
                                onError: [[`errorModal`, `setText`, `1 step onError`]]
                            },
                            {
                                onBefore: [
                                    ['spectrophotometerApparat', 'enableInteraction', 'transmittance'],
                                    [
                                        `taskScreen`, `init`,
                                        `Task ${i + 2}.3: Calibrate for a wavelength of ${waveLength}nm`,
                                        `Adjust the transmittance to 100%.`,
                                        `First select the transmittance knob. \n ` +
                                            `Next, press the + or - buttons to set the transmittance to 100%.`,
                                        .9
                                    ]
                                ],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    var _a;
                                    if ((_a = Viewer.zSpace) === null || _a === void 0 ? void 0 : _a.enabled) {
                                        this.taskScreen.init(`Task ${i + 2}.3: Calibrate for a wavelength of ${waveLength}nm`, `Adjust the transmittance to 100%.`, 'First select the transmittance knob. \n ' +
                                            `Next, press the Left or Right buttons to set the transmittance to 100%.`, 0.9);
                                    }
                                    this.spectrophotometerApparat.once('numericValueChanged', (event) => event.data.valueChanged === 'transmittance' && event.data.newValue === 100, () => {
                                        this.spectrophotometerApparat.plusButton.uiObject.visible = false;
                                        this.spectrophotometerApparat.minusButton.uiObject.visible = false;
                                        resolve();
                                    });
                                }),
                                onAfter: [
                                    ['spectrophotometerApparat', 'toggleCap', true],
                                    ['spectrophotometerApparat', 'enableInteraction', null]
                                ],
                                onError: [[`errorModal`, `setText`, `1 step onError`]]
                            },
                            {
                                onBefore: [
                                    [
                                        `taskScreen`, `init`,
                                        `Task ${i + 2}.3: Calibrate for a wavelength of ${waveLength}nm`,
                                        `Remove the blank tube.`,
                                        `Drag the blank tube from the spectrophotometer and return it to the holding rack.`,
                                        1.0
                                    ],
                                ],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    this.testTube1.setDraggable(true);
                                    this.testTube1.once('took', () => {
                                        const wrapTestTubePlaceholder = this.testTube1.placeholder.object;
                                        wrapTestTubePlaceholder.children[0].visible = true;
                                        if (!Viewer.controls.zController) {
                                            this.actionController.once(ActionControllerEventName.click, wrapTestTubePlaceholder, () => {
                                                this.testTubesHolder.addObject(this.testTube1.model);
                                                this.testTube1.model.userData.tablePosition = this.testTube1.model.position.clone();
                                                Viewer.pointerController.setObject(null);
                                                this.testTube1.model.position.copy(wrapTestTubePlaceholder.position);
                                                wrapTestTubePlaceholder.children[0].visible = false;
                                                resolve();
                                            });
                                        }
                                        else {
                                            this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.testTube1.model, () => {
                                                const distanceToTubePlaceholder = wrapTestTubePlaceholder.getWorldPosition(new Vector3()).distanceTo(this.testTube1.model.getWorldPosition(new Vector3()));
                                                if (distanceToTubePlaceholder < 1.1) {
                                                    this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.testTube1.model);
                                                    this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.testTube1.model);
                                                    this.testTubesHolder.addObject(this.testTube1.model);
                                                    this.testTube1.model.userData.tablePosition = this.testTube1.model.position.clone();
                                                    this.testTube1.model.position.copy(wrapTestTubePlaceholder.position);
                                                    this.testTube1.model.scale.copy(this.testTube1.model.userData.prevScale);
                                                    this.testTube1.model.quaternion.copy(this.testTube1.model.userData.prevQuaternion);
                                                    wrapTestTubePlaceholder.children[0].visible = false;
                                                    resolve();
                                                }
                                                else {
                                                    PreparationPickingObjects.flyObjectToPrevState(this.testTube1.model, 0);
                                                }
                                                setTimeout(() => this.testTube1.model.traverse(el => {
                                                    if (el.userData.oldRaycast)
                                                        el.raycast = el.userData.oldRaycast;
                                                }));
                                            });
                                        }
                                    });
                                }),
                                onError: [[`errorModal`, `setText`, `1 step onError`]]
                            },
                            {
                                onBefore: [
                                    [
                                        `taskScreen`, `init`,
                                        `Task ${i + 2}.4: Observe and Report`,
                                        `Place the sample tube in the spectrophotometer.`,
                                        `Select the sample tube with the red food coloring and drag it to the spectrophotometer.`,
                                        .8
                                    ],
                                ],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    this.testTube2.setDraggable(true);
                                    this.testTube2.once('took', () => {
                                        const wrapTubePlaceholder = placeholdersApparat.object;
                                        wrapTubePlaceholder.children[0].visible = true;
                                        if (!Viewer.controls.zController) {
                                            this.actionController.once(ActionControllerEventName.click, wrapTubePlaceholder, () => {
                                                Viewer.pointerController.setObject(null);
                                                this.testTube2.model.userData.tablePosition = this.testTube2.model.position.clone();
                                                this.testTube2.model.userData.tableParent = this.testTube2.model.parent;
                                                this.spectrophotometerApparat.addObject(this.testTube2.model);
                                                this.testTube2.model.position.copy(wrapTubePlaceholder.position);
                                                wrapTubePlaceholder.children[0].visible = false;
                                                resolve();
                                            });
                                        }
                                        else {
                                            this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.testTube2.model, () => {
                                                const distanceToTubePlaceholder = wrapTubePlaceholder.getWorldPosition(new Vector3()).distanceTo(this.testTube2.model.getWorldPosition(new Vector3()));
                                                if (distanceToTubePlaceholder < 1.1) {
                                                    this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.testTube2.model);
                                                    this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.testTube2.model);
                                                    this.testTube2.model.userData.tablePosition = this.testTube2.model.position.clone();
                                                    this.testTube2.model.userData.tableParent = this.testTube2.model.parent;
                                                    this.spectrophotometerApparat.addObject(this.testTube2.model);
                                                    this.testTube2.model.position.copy(wrapTubePlaceholder.position);
                                                    this.testTube2.model.quaternion.copy(wrapTubePlaceholder.quaternion);
                                                    this.testTube2.model.scale.copy(wrapTubePlaceholder.scale);
                                                    wrapTubePlaceholder.children[0].visible = false;
                                                    resolve();
                                                }
                                                else {
                                                    PreparationPickingObjects.flyObjectToPrevState(this.testTube2.model, 0);
                                                }
                                                setTimeout(() => this.testTube2.model.traverse(el => {
                                                    if (el.userData.oldRaycast)
                                                        el.raycast = el.userData.oldRaycast;
                                                }));
                                            });
                                        }
                                    });
                                }),
                                onAfter: [['spectrophotometerApparat', 'setValues', values_array[i].transmittance, values_array[i].absorbance], ['spectrophotometerApparat', 'toggleCap', false]],
                                onError: [[`errorModal`, `setText`, `1 step onError`]]
                            },
                            {
                                onBefore: [
                                    [
                                        `taskScreen`, `init`,
                                        `Task ${i + 2}.4: Observe and Report`,
                                        `Observe & record transmittance.`,
                                        `Click on the notebook to record the transmittance on the display.`,
                                        .9
                                    ],
                                    ['notebook', 'flyToUser', true]
                                ],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    this.notebook.once('entered', (event) => {
                                        const _reject = () => {
                                            event.data.input.clear();
                                            reject();
                                        };
                                        if (event.data.wavelength !== waveLength)
                                            _reject();
                                        else if (event.data.type !== 'transmittance')
                                            _reject();
                                        else if (+event.data.value !== values_array[i].transmittance)
                                            _reject();
                                        else
                                            resolve();
                                    });
                                }),
                                onAfter: [['notebook', 'flyToUser', false]],
                                onError: [[`errorModal`, `setVisible`, true]]
                            },
                            {
                                onBefore: [
                                    ['spectrophotometerApparat', 'enableInteraction', 'mode'],
                                    [
                                        `taskScreen`, `init`,
                                        `Task ${i + 2}.4: Observe and Report`,
                                        `Observe & record absorbance.`,
                                        `First, press the mode button to change the mode to absorbance. \n ` +
                                            `Next, click on the notebook to record the absorbance on the display.`,
                                        0.8
                                    ]
                                ],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    this.spectrophotometerApparat.once('modeChanged', (event) => event.data.newValue === 1, () => resolve());
                                }),
                                onAfter: [['spectrophotometerApparat', 'enableInteraction', null]],
                                onError: [[`errorModal`, `setText`, `1 step onError`]]
                            }, {
                                onBefore: [['notebook', 'flyToUser', true]],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    this.notebook.once('entered', (event) => {
                                        const _reject = () => {
                                            event.data.input.clear();
                                            reject();
                                        };
                                        if (event.data.wavelength !== waveLength)
                                            _reject();
                                        else if (event.data.type !== 'absorbance')
                                            _reject();
                                        else if (+event.data.value !== values_array[i].absorbance)
                                            _reject();
                                        else
                                            resolve();
                                    });
                                }),
                                onAfter: [['notebook', 'flyToUser', false]],
                                onError: [[`errorModal`, `setText`, 'Wrong value entered. \n Try again.']]
                            },
                            {
                                onBefore: [
                                    [
                                        `taskScreen`, `init`,
                                        `Task ${i + 2}.4: Observe and Report`,
                                        `Remove sample tube.`,
                                        `Drag the sample tube from the spectrophotometer to the holding rack.`,
                                        1
                                    ],
                                    ['spectrophotometerApparat', 'toggleCap', true],
                                ],
                                stepCondition: () => new Promise((resolve, reject) => {
                                    this.testTube2.setDraggable(true);
                                    this.testTube2.once('took', () => {
                                        const wrapTestTubePlaceholder = this.testTube2.placeholder.object;
                                        wrapTestTubePlaceholder.children[0].visible = true;
                                        if (!Viewer.controls.zController) {
                                            this.actionController.once(ActionControllerEventName.click, wrapTestTubePlaceholder, () => {
                                                this.testTubesHolder.addObject(this.testTube2.model);
                                                this.testTube2.model.userData.tablePosition = this.testTube2.model.position.clone();
                                                Viewer.pointerController.setObject(null);
                                                this.testTube2.model.position.copy(wrapTestTubePlaceholder.position);
                                                wrapTestTubePlaceholder.children[0].visible = false;
                                                resolve();
                                            });
                                        }
                                        else {
                                            this.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.testTube2.model, () => {
                                                const distanceToTubePlaceholder = wrapTestTubePlaceholder.getWorldPosition(new Vector3()).distanceTo(this.testTube2.model.getWorldPosition(new Vector3()));
                                                if (distanceToTubePlaceholder < 1.1) {
                                                    this.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.testTube2.model);
                                                    this.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.testTube2.model);
                                                    this.testTubesHolder.addObject(this.testTube2.model);
                                                    this.testTube2.model.userData.tablePosition = this.testTube2.model.position.clone();
                                                    this.testTube2.model.position.copy(wrapTestTubePlaceholder.position);
                                                    this.testTube2.model.scale.copy(this.testTube2.model.userData.prevScale);
                                                    this.testTube2.model.quaternion.copy(this.testTube2.model.userData.prevQuaternion);
                                                    wrapTestTubePlaceholder.children[0].visible = false;
                                                    resolve();
                                                }
                                                else {
                                                    PreparationPickingObjects.flyObjectToPrevState(this.testTube2.model, 0);
                                                }
                                                setTimeout(() => this.testTube2.model.traverse(el => {
                                                    if (el.userData.oldRaycast)
                                                        el.raycast = el.userData.oldRaycast;
                                                }));
                                            });
                                        }
                                    });
                                }),
                                onError: [[`errorModal`, `setText`, `1 step onError`]]
                            }
                        ]);
                    });
                    arr = arr.filter(a => a);
                    return arr;
                })(),
                {
                    onBefore: [
                        [
                            `taskScreen`, `init`,
                            `RESULT`, `Graph from input data.`,
                            `If you continue experiment and write all measurements till ~680nm, you can get next graph from input data.`,
                            1
                        ],
                        () => {
                        }
                    ],
                    stepCondition: () => new Promise((resolve, reject) => {
                        let divider = Viewer.controls.zController ? 1.1 : 2;
                        // Create mesh with graph texture:
                        const mesh = new Mesh(new PlaneGeometry(12.73 / divider, 9.08 / divider), new MeshBasicMaterial({ map: ResourcesManager.getTexture('spectro_graph') }));
                        this.uiContainer.add(mesh);
                        mesh.position.set(0, .18, 1.48);
                        if (Viewer.controls.zController)
                            mesh.position.z = 0;
                        mesh.rotation.set(0, 0, 0);
                        this.actionController.once(ActionControllerEventName.click, mesh, () => {
                            this.removeObject(mesh);
                            resolve();
                        });
                    }),
                    onError: [[`errorModal`, `setText`, `1 step onError`]]
                },
                {
                    onBefore: [[
                            'welcomeScreen', 'init',
                            'Experiment finished!',
                            'You have successfully accomplished the experiment.',
                            'Back to Lobby'
                        ]],
                    stepCondition: () => new Promise((resolve, reject) => {
                        this.welcomeScreen.uiObject.visible = true;
                        this.levelFinished = true;
                    }),
                },
            ]
        };
        const scenarioProcessor = new ScenarioProcessor(this.scenario);
        scenarioProcessor.init();
    }
    update() {
    }
    showInfo(isShow = true) {
        this.title.uiObject.visible = isShow;
        this.uiContainer.visible = !isShow;
    }
    hideAllInfo() {
        this.uiContainer.visible = this.title.uiObject.visible = false;
    }
}
